<div class="task-detail-page vc-view-shell">
  <!-- Loading state -->
  @if (isLoading) {
    <main class="task-detail-page__layout vc-view-content">
      <section class="task-detail-page__frame vc-surface-panel">
        <div class="task-detail-loading">
          <p-progressSpinner
            [style]="{ width: '50px', height: '50px' }"
          ></p-progressSpinner>
          <span>{{ 'TASKS.DETAIL.LOADING' | translate }}</span>
        </div>
      </section>
    </main>
  } @else if (task || isCreateMode) {
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <main class="task-detail-page__layout vc-view-content">
      <section class="task-detail-page__frame vc-surface-panel">
        <div class="task-detail">

          <!-- Header -->
          <div class="task-detail__header">
      <button
        pButton
        type="button"
        icon="fas fa-arrow-left"
        [label]="'TASKS.DETAIL.BACK' | translate"
        class="p-button-text"
        (click)="goBack()"
      ></button>

            <div class="task-detail__actions">
        @if (isCreateMode) {
          <button
            pButton
            type="button"
            icon="fas fa-save"
            [label]="'TASKS.DETAIL.CREATE' | translate"
            class="p-button-primary"
            (click)="saveChanges()"
            [loading]="isSaving"
          ></button>
        }
        <!-- Editar: Solo el creador -->
        @if (!isCreateMode && canEditTask()) {
          <button
            pButton
            type="button"
            [icon]="isEditing ? 'fas fa-times' : 'fas fa-edit'"
            [label]="isEditing ? ('TASKS.DETAIL.CANCEL' | translate) : ('TASKS.DETAIL.EDIT' | translate)"
            [class]="
              isEditing
                ? 'p-button-outlined p-button-secondary'
                : 'p-button-outlined'
            "
            (click)="toggleEdit()"
            [disabled]="isSaving"
          ></button>
          @if (isEditing) {
            <button
              pButton
              type="button"
              icon="fas fa-save"
              [label]="'TASKS.DETAIL.SAVE' | translate"
              class="p-button-primary"
              (click)="saveChanges()"
              [loading]="isSaving"
            ></button>
          }
        }
        <!-- Cambiar estado: Creador o asignado -->
        @if (!isCreateMode && !isEditing && canChangeTaskStatus()) {
          @if (task.status !== "completed") {
            <button
              pButton
              type="button"
              icon="fas fa-check"
              [label]="'TASKS.DETAIL.MARK_COMPLETED' | translate"
              class="p-button-success"
              (click)="markAsCompleted()"
            ></button>
          }
          @if (task.status === "completed") {
            <button
              pButton
              type="button"
              icon="fas fa-redo"
              [label]="'TASKS.DETAIL.REOPEN' | translate"
              class="p-button-warning"
              (click)="reopenTask()"
            ></button>
          }
        }
        <!-- Eliminar: Solo el creador -->
        @if (!isCreateMode && canEditTask()) {
          <button
            pButton
            type="button"
            icon="fas fa-trash"
            class="p-button-danger p-button-outlined"
            (click)="deleteTask()"
            [pTooltip]="'TASKS.DETAIL.DELETE_TOOLTIP' | translate"
          ></button>
        }
            </div>
          </div>

          <div class="task-detail__content">
      <!-- Main content -->
      <div class="task-detail__main">
        <!-- Card principal -->
        <div class="detail-card">
          <!-- Badges -->
          @if (!isCreateMode && task) {
          <div class="detail-badges">
            <!-- Task Key (estilo JIRA) -->
            <span class="task-key-badge">
              <i class="fas fa-hashtag"></i>
              {{ task.task_key }}
            </span>
            <span
              class="priority-badge"
              [ngClass]="'priority-' + task.priority"
            >
              <i
                [ngClass]="{
                  'fas fa-exclamation-circle': task.priority === 'urgent',
                  'fas fa-arrow-up': task.priority === 'high',
                  'fas fa-minus': task.priority === 'medium',
                  'fas fa-arrow-down': task.priority === 'low',
                }"
              ></i>
              {{ getPriorityLabel(task.priority) }}
            </span>
            <span class="status-badge" [ngClass]="'status-' + task.status">
              <i
                [ngClass]="{
                  'fas fa-clock': task.status === 'pending',
                  'fas fa-spinner': task.status === 'in-progress',
                  'fas fa-check-circle': task.status === 'completed',
                  'fas fa-ban': task.status === 'cancelled',
                }"
              ></i>
              {{ getStatusLabel(task.status) }}
            </span>
            <!-- Indicador de subtarea -->
            @if (task.parent) {
              <span
                class="subtask-badge"
                (click)="openTaskByKey(task.parent.task_key, task.parent.id)"
                [pTooltip]="'TASKS.UI.ACTIONS.VIEW' | translate"
              >
                <i class="fas fa-level-up-alt"></i>
                {{ 'TASKS.DETAIL.SUBTASK_OF' | translate:{ key: task.parent.task_key } }}
              </span>
            }
          </div>
          }

          <!-- Título -->
          @if (!isEditing && !isCreateMode) {
            <div class="detail-field">
              <h1 class="detail-title">{{ task.title }}</h1>
            </div>
          } @else {
            <div class="detail-field">
              <label class="field-label">{{ 'TASKS.DETAIL.TITLE_LABEL' | translate }}</label>
              <input
                type="text"
                pInputText
                [(ngModel)]="editTitle"
                class="w-full"
                placeholder="{{ 'TASKS.DETAIL.TITLE_PLACEHOLDER' | translate }}"
              />
            </div>
          }

          <!-- Descripción -->
          <div class="detail-field">
            <label class="field-label">
              <i class="fas fa-align-left"></i>
              {{ 'TASKS.DETAIL.DESCRIPTION_LABEL' | translate }}
            </label>
            @if (!isEditing && !isCreateMode) {
              <p class="detail-description">
                {{ task.description || ('TASKS.DETAIL.NO_DESCRIPTION' | translate) }}
              </p>
            } @else {
              <textarea
                pInputTextarea
                [(ngModel)]="editDescription"
                rows="4"
                class="w-full"
                placeholder="{{ 'TASKS.DETAIL.DESCRIPTION_PLACEHOLDER' | translate }}"
              ></textarea>
            }
          </div>

          <p-divider></p-divider>

          <!-- Fecha límite -->
          <div class="detail-field">
            <label class="field-label">
              <i class="fas fa-calendar-alt"></i>
              {{ 'TASKS.DETAIL.DUE_DATE_LABEL' | translate }}
            </label>
            @if (!isEditing && !isCreateMode) {
              <div class="detail-value">
                {{ formatDate(task.due_date) }}
              </div>
            } @else {
              <p-calendar
                [(ngModel)]="editDueDate"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                styleClass="w-full"
              ></p-calendar>
            }
          </div>

          <!-- Prioridad -->
          <div class="detail-field">
            <label class="field-label">
              <i class="fas fa-flag"></i>
              {{ 'TASKS.DETAIL.PRIORITY_LABEL' | translate }}
            </label>
            @if (!isEditing && !isCreateMode) {
              <div class="detail-value">
                <span
                  class="priority-indicator"
                  [ngClass]="'priority-' + task.priority"
                ></span>
                {{ getPriorityLabel(task.priority) }}
              </div>
            } @else {
              <p-dropdown
                [(ngModel)]="editPriority"
                [options]="priorityOptions"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
              >
                <ng-template pTemplate="selectedItem" let-item>
                  @if (item) {
                    <div class="priority-option">
                      <i [class]="item.icon" [style.color]="item.color"></i>
                      {{ item.label }}
                    </div>
                  }
                </ng-template>
                <ng-template pTemplate="item" let-item>
                  <div class="priority-option">
                    <i [class]="item.icon" [style.color]="item.color"></i>
                    {{ item.label }}
                  </div>
                </ng-template>
              </p-dropdown>
            }
          </div>

          <!-- Estado -->
          <div class="detail-field">
            <label class="field-label">
              <i class="fas fa-tasks"></i>
              {{ 'TASKS.DETAIL.STATUS_LABEL' | translate }}
            </label>
            @if (!isEditing && !isCreateMode) {
              <div class="detail-value">
                {{ getStatusLabel(task.status) }}
              </div>
            } @else {
              <p-dropdown
                [(ngModel)]="editStatus"
                [options]="statusOptions"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
              >
              </p-dropdown>
            }
          </div>

          <!-- Asignado a -->
          <div class="detail-field">
            <label class="field-label">
              <i class="fas fa-user"></i>
              {{ 'TASKS.DETAIL.ASSIGNEES_LABEL' | translate }}
            </label>
            @if (!isEditing && !isCreateMode) {
              <div class="detail-value assignee-value">
                @if (task.assignees && task.assignees.length > 0) {
                  <div class="assignee-avatars">
                    @for (assignee of task.assignees; track assignee.id) {
                      <span
                        class="assignee-avatar"
                        [style.background-color]="getAssigneeAvatarColor(assignee.id)"
                        [pTooltip]="assignee.name + ' ' + (assignee.surname || '')"
                      >
                        {{ getUserShortLabel(assignee) }}
                      </span>
                    }
                  </div>
                } @else if (getAssigneeName() !== ('TASKS.UI.ASSIGNEE.NONE' | translate)) {
                  <span
                    class="assignee-avatar"
                    [style.background-color]="getAssigneeColor()"
                  >
                    {{ getAssigneeInitials() }}
                  </span>
                  <span>{{ getAssigneeName() }}</span>
                } @else {
                  <span class="assignee-empty">{{ 'TASKS.UI.ASSIGNEE.NONE' | translate }}</span>
                }
              </div>
            } @else {
              @if (selectedUsers.length > 0) {
                <div class="selected-users-list">
                  @for (user of selectedUsers; track user.id) {
                    <div class="selected-user-chip">
                      <span class="user-avatar" [style.background-color]="user.color">
                        {{ user.initials }}
                      </span>
                      <span class="user-name">{{ user.name }}</span>
                      <button
                        pButton
                        type="button"
                        icon="fas fa-times"
                        class="p-button-rounded p-button-text p-button-danger p-button-sm remove-user-btn"
                        (click)="removeUser(user.id)"
                        [disabled]="isSaving"
                      ></button>
                    </div>
                  }
                </div>
              }
              <p-dropdown
                [options]="users"
                optionLabel="name"
                placeholder="{{ 'TASKS.DETAIL.ASSIGNEE_PLACEHOLDER' | translate }}"
                styleClass="w-full"
                [showClear]="false"
                [disabled]="isSaving"
                (onChange)="addUser($event.value)"
                [filter]="true"
                filterBy="name"
              >
                <ng-template pTemplate="selectedItem">
                  <span class="placeholder-text">{{ 'TASKS.DETAIL.ASSIGNEE_ADD_MORE' | translate }}</span>
                </ng-template>
                <ng-template pTemplate="item" let-user>
                  <div class="user-item" [class.user-item--selected]="isUserSelected(user.id)">
                    <span class="user-avatar" [style.background-color]="user.color">
                      {{ user.initials }}
                    </span>
                    <span>{{ user.name }}</span>
                    @if (isUserSelected(user.id)) {
                      <i class="fas fa-check user-selected-icon"></i>
                    }
                  </div>
                </ng-template>
              </p-dropdown>
            }
          </div>

          <!-- Vincular pacientes/citas en edición -->
          @if (isEditing || isCreateMode) {
            <div class="link-section">
              <div class="link-section__header" (click)="togglePatientSearch()">
                <div class="link-section__title">
                  <i class="fas fa-user-injured"></i>
                  <span>{{ 'TASKS.DETAIL.LINK.PATIENTS' | translate }}</span>
                  @if (selectedPatients.length > 0) {
                    <span class="link-section__badge">{{ selectedPatients.length }}</span>
                  }
                </div>
                <i
                  class="fas"
                  [ngClass]="showPatientSearch ? 'fa-chevron-up' : 'fa-chevron-down'"
                ></i>
              </div>

              @if (showPatientSearch) {
                <div class="link-section__content">
                  @if (selectedPatients.length > 0) {
                    <div class="selected-items-list">
                      @for (patient of selectedPatients; track patient.id) {
                        <div class="selected-item-card selected-item-card--compact">
                          <div class="selected-item-card__info">
                            <span class="selected-item-card__avatar">{{ patient.initials }}</span>
                            <div class="selected-item-card__details">
                              <span class="selected-item-card__name">{{ patient.name }}</span>
                              <span class="selected-item-card__meta">
                                @if (patient.phone) {
                                  <i class="fas fa-phone"></i> {{ patient.phone }}
                                }
                                @if (patient.email) {
                                  · {{ patient.email }}
                                }
                              </span>
                            </div>
                          </div>
                          <button
                            pButton
                            type="button"
                            icon="fas fa-times"
                            class="p-button-rounded p-button-text p-button-danger p-button-sm"
                            (click)="removePatient(patient.id)"
                          ></button>
                        </div>
                      }
                    </div>
                  }

                  <div class="search-box">
                    <p-autoComplete
                      [(ngModel)]="patientSearchStr"
                      [suggestions]="filteredPatients"
                      (completeMethod)="searchPatients($event)"
                      (onSelect)="onSelectPatient($event)"
                      field="name"
                      placeholder="{{ 'TASKS.DETAIL.PATIENT_SEARCH_PLACEHOLDER' | translate }}"
                      styleClass="w-full"
                      inputStyleClass="w-full"
                    >
                      <ng-template let-patient pTemplate="item">
                        <div class="autocomplete-item">
                          <span class="autocomplete-item__avatar">{{ patient.initials }}</span>
                          <div class="autocomplete-item__info">
                            <span class="autocomplete-item__name">{{ patient.name }}</span>
                            <span class="autocomplete-item__meta">
                              @if (patient.phone) {
                                <i class="fas fa-phone"></i> {{ patient.phone }}
                              }
                              @if (patient.email) {
                                · {{ patient.email }}
                              }
                            </span>
                          </div>
                        </div>
                      </ng-template>
                    </p-autoComplete>
                    <p class="search-hint">
                      <i class="fas fa-info-circle"></i>
                      {{ 'TASKS.DETAIL.SEARCH_HINT' | translate }}
                    </p>
                  </div>
                </div>
              }
            </div>

            <div class="link-section">
              <div class="link-section__header" (click)="toggleAppointmentSearch()">
                <div class="link-section__title">
                  <i class="fas fa-calendar-check"></i>
                  <span>{{ 'TASKS.DETAIL.LINK.APPOINTMENTS' | translate }}</span>
                  @if (selectedAppointments.length > 0) {
                    <span class="link-section__badge">{{ selectedAppointments.length }}</span>
                  }
                </div>
                <i
                  class="fas"
                  [ngClass]="showAppointmentSearch ? 'fa-chevron-up' : 'fa-chevron-down'"
                ></i>
              </div>

              @if (showAppointmentSearch) {
                <div class="link-section__content">
                  @if (selectedAppointments.length > 0) {
                    <div class="selected-items-list">
                      @for (appointment of selectedAppointments; track appointment.id) {
                        <div class="selected-item-card selected-item-card--compact">
                          <div class="selected-item-card__info">
                            <span class="selected-item-card__icon">
                              <i class="fas fa-calendar"></i>
                            </span>
                            <div class="selected-item-card__details">
                              <span class="selected-item-card__name">{{ appointment.patientName }}</span>
                              <span class="selected-item-card__meta">
                                {{ formatAppointmentDate(appointment.date) }} · {{ appointment.time }}
                              </span>
                            </div>
                          </div>
                          <button
                            pButton
                            type="button"
                            icon="fas fa-times"
                            class="p-button-rounded p-button-text p-button-danger p-button-sm"
                            (click)="removeAppointment(appointment.id)"
                          ></button>
                        </div>
                      }
                    </div>
                  }

                  @if (patientAppointments.length > 0) {
                    <div class="patient-appointments-section">
                      <h4 class="patient-appointments-title">
                        <i class="fas fa-calendar-alt"></i>
                        {{ 'TASKS.APPOINTMENTS.SELECTED_PATIENTS_TITLE' | translate }}
                      </h4>
                      <div class="patient-appointments-toolbar">
                        <input
                          pInputText
                          type="text"
                          placeholder="{{ 'TASKS.APPOINTMENTS.SEARCH_PLACEHOLDER' | translate }}"
                          class="patient-appointments-search"
                          (input)="patientAppointmentsTable.filterGlobal($any($event.target).value, 'contains')"
                        />
                        <p-calendar
                          [(ngModel)]="appointmentFilterDate"
                          dateFormat="dd/mm/yy"
                          [showIcon]="true"
                          inputStyleClass="patient-appointments-date"
                          (onSelect)="onAppointmentFilterDateChange()"
                          (onClear)="clearAppointmentFilterDate()"
                          [showClear]="true"
                        ></p-calendar>
                        <span class="patient-appointments-count">
                          {{ 'TASKS.APPOINTMENTS.TOTAL_LABEL' | translate }}: {{ patientAppointments.length }}
                        </span>
                      </div>
                      <p-table
                        #patientAppointmentsTable
                        [value]="filteredPatientAppointments"
                        [scrollable]="true"
                        scrollHeight="240px"
                        sortMode="multiple"
                        [globalFilterFields]="['patientName','treatment','status','time','date']"
                        styleClass="patient-appointments-table"
                      >
                        <ng-template pTemplate="header">
                          <tr>
                            <th pSortableColumn="date">{{ 'TASKS.APPOINTMENTS.TABLE.DATE' | translate }} <p-sortIcon field="date"></p-sortIcon></th>
                            <th pSortableColumn="patientName">{{ 'TASKS.APPOINTMENTS.TABLE.PATIENT' | translate }} <p-sortIcon field="patientName"></p-sortIcon></th>
                            <th pSortableColumn="treatment">{{ 'TASKS.APPOINTMENTS.TABLE.TREATMENT' | translate }} <p-sortIcon field="treatment"></p-sortIcon></th>
                            <th pSortableColumn="time">{{ 'TASKS.APPOINTMENTS.TABLE.TIME' | translate }} <p-sortIcon field="time"></p-sortIcon></th>
                            <th pSortableColumn="total">{{ 'TASKS.APPOINTMENTS.TABLE.TOTAL' | translate }} <p-sortIcon field="total"></p-sortIcon></th>
                            <th></th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-apt>
                          <tr class="patient-appointments-row" (click)="addPatientAppointment(apt)">
                            <td>{{ formatAppointmentDate(apt.date) }}</td>
                            <td>{{ apt.patientName }}</td>
                            <td>{{ apt.treatment }}</td>
                            <td>{{ apt.time }}</td>
                            <td>{{ apt.total | currency:'EUR' }}</td>
                            <td class="patient-appointments-action">
                              <button
                                pButton
                                type="button"
                                icon="fas fa-plus"
                                class="p-button-rounded p-button-text p-button-sm"
                                (click)="addPatientAppointment(apt); $event.stopPropagation()"
                              ></button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </div>
                  }

                  @if (filteredAppointments.length > 0) {
                    <div class="appointments-list">
                      @for (apt of filteredAppointments; track apt.id) {
                        <div class="appointment-card" (click)="onSelectAppointment(apt)">
                          <div class="appointment-card__date">
                            <span class="appointment-card__day">{{ apt.date.getDate() }}</span>
                            <span class="appointment-card__month">{{ formatAppointmentDate(apt.date).split(' ')[0] }}</span>
                          </div>
                          <div class="appointment-card__info">
                            <span class="appointment-card__patient">{{ apt.patientName }}</span>
                            <span class="appointment-card__treatment">{{ apt.treatment }}</span>
                          </div>
                          <div class="appointment-card__time">
                            <i class="fas fa-clock"></i>
                            {{ apt.time }}
                          </div>
                          <span class="appointment-card__total">{{ apt.total | currency:'EUR' }}</span>
                          <span class="appointment-card__status">{{ apt.status }}</span>
                        </div>
                      }
                    </div>
                  } @else if (showAppointmentSearch) {
                    <div class="no-results">
                      <i class="fas fa-calendar-times"></i>
                      {{ 'TASKS.APPOINTMENTS.NO_RESULTS' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          }

          <!-- Vinculaciones: Múltiples pacientes y citas -->
          @if (!isCreateMode && !isEditing && ((task.patients && task.patients.length > 0) || (task.appointments && task.appointments.length > 0))) {
            <div class="detail-links">
              <p-divider></p-divider>
              <label class="field-label">
                <i class="fas fa-link"></i>
                {{ 'TASKS.DETAIL.LINKS.TITLE' | translate }}
              </label>

              <!-- Pacientes vinculados -->
              @if (task.patients && task.patients.length > 0) {
                <div class="links-group">
                  <span class="links-group__label">
                    <i class="fas fa-user-injured"></i>
                    {{ 'TASKS.DETAIL.LINKED.PATIENTS' | translate:{ count: task.patients.length } }}
                  </span>
                  @for (patient of task.patients; track patient.id) {
                    <div class="link-card">
                      <i class="fas fa-user-injured link-icon"></i>
                      <div class="link-info">
                        <span class="link-name">{{ patient.name }} {{ patient.surname || '' }}</span>
                        <span class="link-meta">
                          @if (patient.phone) {
                            <i class="fas fa-phone"></i> {{ patient.phone }}
                          }
                          @if (patient.email) {
                            · {{ patient.email }}
                          }
                        </span>
                      </div>
                      <button
                        pButton
                        type="button"
                        icon="fas fa-external-link-alt"
                        class="p-button-text p-button-sm"
                        [pTooltip]="'TASKS.APPOINTMENTS.VIEW_PATIENT' | translate"
                        (click)="openPatient(patient.id)"
                      ></button>
                    </div>
                  }
                </div>
              }

              <!-- Citas vinculadas -->
              @if (task.appointments && task.appointments.length > 0) {
                <div class="links-group">
                  <span class="links-group__label">
                    <i class="fas fa-calendar-check"></i>
                    {{ 'TASKS.DETAIL.LINKED.APPOINTMENTS' | translate:{ count: task.appointments.length } }}
                  </span>
                  @for (appointment of task.appointments; track appointment.id) {
                    <div class="link-card">
                      <i class="fas fa-calendar-check link-icon"></i>
                      <div class="link-info">
                        <span class="link-name">
                          {{
                            appointment.name ||
                              ('TASKS.APPOINTMENTS.DEFAULT_NAME' | translate)
                          }}
                        </span>
                        <span class="link-meta">
                          {{ formatDateTime(appointment.start) }}
                        </span>
                      </div>
                      <button
                        pButton
                        type="button"
                        icon="fas fa-external-link-alt"
                        class="p-button-text p-button-sm"
                        [pTooltip]="'TASKS.APPOINTMENTS.VIEW_APPOINTMENT' | translate"
                        (click)="openAppointment(appointment.id)"
                      ></button>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <!-- Subtareas -->
          @if (!isCreateMode && task.subtasks && task.subtasks.length > 0) {
            <div class="detail-subtasks">
              <p-divider></p-divider>
              <label class="field-label">
                <i class="fas fa-sitemap"></i>
                {{ 'TASKS.DETAIL.SUBTASKS' | translate:{ count: task.subtasks.length } }}
              </label>
              <div class="subtasks-list">
                @for (subtask of task.subtasks; track subtask.id) {
                  <div
                    class="subtask-card"
                    [ngClass]="'subtask-status-' + subtask.status"
                    (click)="openTaskByKey(subtask.task_key, subtask.id)"
                  >
                    <span class="subtask-key">{{ subtask.task_key }}</span>
                    <span class="subtask-title">{{ subtask.title }}</span>
                    <span class="subtask-status" [ngClass]="'status-' + subtask.status">
                      {{ getStatusLabel(subtask.status) }}
                    </span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Sidebar: Comentarios -->
      @if (!isCreateMode) {
      <div class="task-detail__sidebar">
        <div class="comments-card">
          <h3 class="comments-title">
            <i class="fas fa-comments"></i>
            {{ 'TASKS.DETAIL.COMMENTS.TITLE' | translate }}
            <span class="comments-count">{{ comments.length }}</span>
          </h3>

          <!-- Añadir comentario -->
          @if (canCommentTask()) {
          <div class="add-comment">
            <div class="add-comment__avatar">
              <span class="avatar avatar--self">YO</span>
            </div>
            <div class="add-comment__input">
              <textarea
                pInputTextarea
                [(ngModel)]="newComment"
                rows="2"
                placeholder="{{ 'TASKS.DETAIL.COMMENTS.PLACEHOLDER' | translate }}"
                class="w-full"
                [disabled]="isAddingComment"
              ></textarea>
              <button
                pButton
                type="button"
                [label]="'TASKS.DETAIL.COMMENTS.SUBMIT' | translate"
                icon="fas fa-paper-plane"
                class="p-button-primary p-button-sm"
                [disabled]="!newComment.trim() || isAddingComment"
                [loading]="isAddingComment"
                (click)="addComment()"
              ></button>
            </div>
          </div>
          } @else {
            <div class="comments-empty">
              <i class="fas fa-lock"></i>
              <span>{{ 'TASKS.DETAIL.COMMENTS.NO_PERMISSION' | translate }}</span>
            </div>
          }

          <p-divider></p-divider>

          <!-- Lista de comentarios -->
          <div class="comments-list">
            @for (comment of comments; track comment.id) {
              <div class="comment">
                <div class="comment__avatar">
                  <span
                    class="avatar"
                    [style.background-color]="getCommentUserColor(comment)"
                  >
                    {{ getCommentUserInitials(comment) }}
                  </span>
                </div>
                <div class="comment__content">
                  <div class="comment__header">
                    <span class="comment__author">{{
                      getCommentUserName(comment)
                    }}</span>
                    <span class="comment__time">{{
                      getTimeAgo(comment.createdAt!)
                    }}</span>
                  </div>
                  <p class="comment__text">{{ comment.content }}</p>
                </div>
                @if (canEditTask()) {
                  <button
                    pButton
                    type="button"
                    icon="fas fa-trash"
                    class="p-button-text p-button-danger p-button-sm comment__delete"
                    [pTooltip]="'TASKS.UI.ACTIONS.DELETE' | translate"
                    (click)="deleteComment(comment.id!)"
                  ></button>
                }
              </div>
            } @empty {
              <div class="comments-empty">
                <i class="fas fa-comment-slash"></i>
                <span>{{ 'TASKS.DETAIL.COMMENTS.EMPTY' | translate }}</span>
              </div>
            }
          </div>
        </div>

        <!-- Info adicional -->
        <div class="info-card">
          <h4 class="info-title">{{ 'TASKS.DETAIL.INFO.TITLE' | translate }}</h4>
          <div class="info-item">
            <span class="info-label">{{ 'TASKS.DETAIL.INFO.KEY' | translate }}</span>
            <span class="info-value info-value--key">{{ task.task_key }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">{{ 'TASKS.DETAIL.INFO.CREATED_BY' | translate }}</span>
            <div class="info-value">
              <span
                class="info-avatar"
                [style.background-color]="getCreatorColor()"
              >
                {{ getCreatorInitials() }}
              </span>
              {{ getCreatorName() }}
            </div>
          </div>
          <div class="info-item">
            <span class="info-label">{{ 'TASKS.DETAIL.INFO.CREATED_AT' | translate }}</span>
            <span class="info-value">{{
              formatDateTime(task.createdAt!)
            }}</span>
          </div>
          @if (task.completed_at) {
            <div class="info-item">
              <span class="info-label">{{ 'TASKS.DETAIL.INFO.COMPLETED_AT' | translate }}</span>
              <span class="info-value">{{
                formatDateTime(task.completed_at)
              }}</span>
            </div>
          }
          @if (task.parent) {
            <div class="info-item">
              <span class="info-label">{{ 'TASKS.DETAIL.INFO.PARENT' | translate }}</span>
              <span
                class="info-value info-value--link"
                (click)="openTaskByKey(task.parent.task_key, task.parent.id)"
              >
                <i class="fas fa-level-up-alt"></i>
                {{ task.parent.task_key }}: {{ task.parent.title }}
              </span>
            </div>
          }
        </div>
      </div>
          }
          </div>
        </div>
      </section>
    </main>
  }
</div>
